import React, {FunctionComponent, useCallback, useEffect, useState} from "react"
import axios from "axios"

const styles = require("../../styles/report-page.module.scss");

declare let require: {
    <T = any>(path: string): T;
    (paths: string[], callback: (...modules: any[]) => void): void;
    ensure: (
        paths: string[],
        callback: (require: <T>(path: string) => T) => void
    ) => void;
};

interface ReportFormProps {
    onSubmit: () => void;
    reportReason: string;
}


export const ReportForm: FunctionComponent<ReportFormProps> = ({onSubmit, reportReason}) => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [company, setCompany] = useState('');
    const [currentURL, setCurrentURL] = useState<URLSearchParams | null>(null);
    const [localStorageFirstSource, setLocalStorageFirstSource] = useState<string | null>(null);
    const [localStorageFinalSource, setLocalStorageFinalSource] = useState<string | null>(null);

    //query params
    const [source, setSource] = useState<string | null>('');
    const [medium, setMedium] = useState<string | null>('');
    const [campaign, setCampaign] = useState<string | null>('');
    const [term, setTerm] = useState<string | null>('');
    const [content, setContent] = useState<string | null>('');

    useEffect(() => {
        if (typeof window !== "undefined") {
            let url = new URL(window.location.href);
            let searchParams = new URLSearchParams(url.search);
            setCurrentURL(searchParams);
            if (searchParams.get('utm_source') !== null) {
                localStorage.setItem('final_source', searchParams.get('utm_source') as string);
                if (localStorage.getItem('first_source') === null) {
                    localStorage.setItem('first_source', searchParams.get('utm_source') as string);
                }
            }
            setLocalStorageFirstSource(window.localStorage.getItem('first_source'));
            setLocalStorageFinalSource(window.localStorage.getItem('final_source'));
        }
    }, [typeof window])

    useEffect(() => {
        if (!currentURL) return;
        currentURL.get('utm_source') && setSource(currentURL.get('utm_source'));
        currentURL.get('utm_medium') && setMedium(currentURL.get('utm_medium'));
        currentURL.get('utm_campaign') && setCampaign(currentURL.get('utm_campaign'));
        currentURL.get('utm_term') && setTerm(currentURL.get('utm_term'));
        currentURL.get('utm_content') && setContent(currentURL.get('utm_content'));
    },[currentURL]);

    const handleNameInput = (e: React.FormEvent<HTMLInputElement>) => {
        setName(e.currentTarget.value);
    };
    const handleEmailInput = (e: React.FormEvent<HTMLInputElement>) => {
        setEmail(e.currentTarget.value);
    };
    const handlePhoneNumberInput = (e: React.FormEvent<HTMLInputElement>) => {
        setPhoneNumber(e.currentTarget.value);
    };
    const handleCompanyInput = (e: React.FormEvent<HTMLInputElement>) => {
        setCompany(e.currentTarget.value);
    };


    const handleSubmit = useCallback(
         (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        axios.get('/ws/ws_contactus.php?stam=' + new Date().getTime(),{
            params: {
                reason: reportReason,
                name: name,
                email: email,
                phone_number: phoneNumber,
                company: company,
                whatToDo: 'send',
                utm_source: localStorageFirstSource || source || undefined,
                utm_medium: medium || undefined,
                utm_campaign: campaign || undefined,
                utm_term: term || undefined,
                utm_content: content || undefined,
                utm_source_final: localStorageFinalSource || undefined
            }
        }).then(function (response) {
            onSubmit(); //show download page
        })
            .catch(function (error) {
                console.log(error);
            })
    }, [name, email, phoneNumber, company ] );

return (
    <form className={styles.formBody} onSubmit={handleSubmit}>
        <fieldset>
            <div className={styles.allRows}>
                <div className={styles.oneFormRow}>
                    <input name="name" placeholder='Full Name' type="text" value={name} onChange={handleNameInput}
                           className={styles.demoForm} required/>
                </div>
                <div className={styles.oneFormRow}>
                    <input name="email" placeholder='Work Email' type="email" value={email} onChange={handleEmailInput}
                           className={styles.demoForm} required/>
                </div>
                <div className={styles.oneFormRow}>
                    <input className={styles.demoForm} name="phone_number" placeholder='Phone Number'
                           value={phoneNumber} onChange={handlePhoneNumberInput}
                           type="tel" required/>
                </div>
                <div className={styles.oneFormRow}>
                    <input className={styles.demoForm} name="company" placeholder='Company Name' value={company}
                           onChange={handleCompanyInput}
                           type="text" required/>
                </div>
            </div>
            <button
                className={`${styles.gradButt} ${styles.gradButtLarge} ${styles.gradButtBlue} ${styles.landingPageCtaButt}`}
                id="submit"
                value="Download Your Free Report" type="submit">Get Your Copy
            </button>
        </fieldset>
    </form>
)
}